<template>
  <div class="container-fluid">
    <SalaryReport />
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Home',
}
</script>
